
export const picUrl = {
  // 标题头图
  titleHeader: 'https://img-ap-hongkong.mykeeta.net/sailorcweb/1a701c27d91b4479ca3cdc51e3f2043b819585.png',
  questionTitleHeader: 'https://img-ap-hongkong.mykeeta.net/sailorcweb/b28f0c115e6cc6b71d9663292d6d1ee0673748.png',
  // 逗号
  comma: 'https://img-ap-hongkong.mykeeta.net/sailorcweb/0e0aafc0b3a4b79c9cb892ddbbb0d27e1479.png',
  // 角色
  after: 'https://img-ap-hongkong.mykeeta.net/sailorcweb/42f84d35ab55573447a89bb982890c599929.png',
  // 用餐场景
  diningScene1: 'https://img-ap-hongkong.mykeeta.net/sailorcweb/b7cc84eed0c5cb86a0172cce73c7aa4b335182.png',
  diningScene2: 'https://img-ap-hongkong.mykeeta.net/sailorcweb/a5ca93ea82fcc5dee748305735378f6b274778.png',
  diningScene3: 'https://img-ap-hongkong.mykeeta.net/sailorcweb/d28c60edadbccd9ce22e9ca335b7bec0327907.png',
  // after-英文
  afterEn: 'https://img-ap-hongkong.mykeeta.net/sailorcweb/5950359c84032c31fffd716125a163b99927.png',
  // ai
  ai: 'https://img-ap-hongkong.mykeeta.net/sailorcweb/ad3a3fc47be7ba0cbd72989e0b129a02591089.png',
  // before-英文
  beforeEn: 'https://img-ap-hongkong.mykeeta.net/sailorcweb/1a7fa43ae8d890fa94916a4369ce9eaa5448.png',
  // before
  before: 'https://img-ap-hongkong.mykeeta.net/sailorcweb/7b4b0d3ae721721733164fe65681d3de5537.png',
  afterBorder: 'https://img-ap-hongkong.mykeeta.net/sailorcweb/552785a62d4996bd71f8f371eb228034392.png',
}

export const DOWNLOAD_LINK = 'https://app.adjust.com/1m4e6ti2'
